// vendor
import React from 'react';
import PropTypes from 'prop-types';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { Row, Col } from 'react-bootstrap';
import 'react-day-picker/lib/style.css';
import moment from 'moment';

// app
import { getWeekDays, getWeekRange } from '../../../utils/utils';
import './style.scss';

class WeekPicker extends React.Component {

  state = {
    hoverRange: undefined,
    selectedDays: []
  };


  clearSelectedWeekDays = () => {
    const { handleSelectWeek } = this.props;

    this.setState({
      selectedDays: []
    });

    handleSelectWeek && handleSelectWeek(null);
  }

  handleDayChange = (date, modifiers = {}) => {

    if (modifiers.disabled) {
      return;
    }

    const { handleSelectWeek } = this.props;

    const days = getWeekDays(getWeekRange(date).from);
    this.setState({
      selectedDays: days
    });

    handleSelectWeek && handleSelectWeek(days);
  };

  handleDayEnter = date => {
    this.setState({
      hoverRange: getWeekRange(date)
    });
  };

  handleDayLeave = () => {
    this.setState({
      hoverRange: undefined
    });
  };

  handleWeekClick = (weekNumber, days) => {
    const { handleSelectWeek } = this.props;
    this.setState({
      selectedDays: days
    });

    handleSelectWeek && handleSelectWeek(days);
  };

  getInputValue = () => {
    const { selectedDays } = this.state;

    if (selectedDays.length === 7) {
      return `${moment(selectedDays[0]).format('ll')} – ${moment(selectedDays[6]).format('ll')}`
    }

    return 'All dates';
  }

  onInputChange = () => {
    this.setState((prevState) => ({ ...prevState }));
  }


  render() {
    const { hoverRange, selectedDays } = this.state;
    const {
      inputClassNames = '',
      inputPlaceholder,
      inputValue: inputPropsValue,
      minDate,
      maxDate,
      inputLabel,
      showClearButton
    } = this.props;

    const daysAreSelected = selectedDays.length > 0;

    const modifiers = {
      hoverRange,
      selectedRange: daysAreSelected && {
        from: selectedDays[0],
        to: selectedDays[6]
      },
      hoverRangeStart: hoverRange && hoverRange.from,
      hoverRangeEnd: hoverRange && hoverRange.to,
      selectedRangeStart: daysAreSelected && selectedDays[0],
      selectedRangeEnd: daysAreSelected && selectedDays[6]
    };

    const inputValue = this.getInputValue();

    const minDateWithOffset = new Date(minDate);
    const maxDateWithOffset = new Date(maxDate);

    const min = new Date(minDateWithOffset.getTime() - minDateWithOffset.getTimezoneOffset() * - 60000);
    const max = new Date(maxDateWithOffset.getTime() - maxDateWithOffset.getTimezoneOffset() * - 60000);

    const dayPickerProps = {
      selectedDays,
      showOutsideDays: true,
      modifiers,
      onDayClick: this.handleDayChange,
      onDayMouseEnter: this.handleDayEnter,
      onDayMouseLeave: this.handleDayLeave,
      onWeekClick: this.handleWeekClick,
      month: min,
      fromMonth: min,
      toMonth: max,
      disabledDays: [{
        after: max,
        before: min
      }]
    };

    return (
      <Row>
        <Col md={12}>
          <div className="selected-week form-group">
            <div className="input-group-week-picker">
              <DayPickerInput
                inputProps={{
                  className: `form-control ${!inputClassNames ? 'week-picker-input': ''} ${ typeof inputClassNames === 'Array' ? inputClassNames.join(' ') : inputClassNames}`,
                  value: inputValue,
                  readOnly: true
                }}
                value={ inputPropsValue || inputValue}
                placeholder={inputPlaceholder}
                dayPickerProps={dayPickerProps}
              />
              {showClearButton && (
                <span
                  className="clear-button"
                  onClick={this.clearSelectedWeekDays}
                >
                  &times;
                </span>
              )}
            </div>
            <div className="input-description">{inputLabel}</div>
          </div>
        </Col>
      </Row>
    );
  }
}

WeekPicker.defaultProps = {
  inputPlaceholder: 'YYYY-M-D – YYYY-M-D',
  inputLabel: 'Filter schedules by week',
  showClearButton: true
}

WeekPicker.propTypes = {
  inputClassNames: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  inputPlaceholder: PropTypes.string,
  inputValue: PropTypes.string,
  handleSelectWeek: PropTypes.func,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  inputLabel: PropTypes.string,
  showClearButton: PropTypes.bool
}

export default WeekPicker;



// WEBPACK FOOTER //
// ./src/components/common/DatePicker/WeekPicker.js